module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-165.b0181feb.svg";